<template>
  <div class="mb-2">
    <b-input-group size="sm">
      <el-upload
        action="/carrier/info/carrierImport"
        ref="upload"
        :http-request="uploadFile"
      >
        <!--update file-->
        <b-button size="sm" variant="outline-success" class="ml-2">
          <i class="el-icon-upload"></i>承运商
        </b-button>
      </el-upload>
    </b-input-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      CarrierInfo: {},
    }
  },

  methods: {
    uploadFile(params) {
      return this.$api.CARRIER_UPLOAD(params.raw).then((res) => {
        this.CarrierInfo = res.body
        this.$emit('getData', this.CarrierInfo)
      })
    },
  },
}
</script>
